<template>
  <div id="app">
    <router-view/>
    <div class="screen-loader-wall" v-show="$store.state.progress.loading">
      <div class="screen-loader">Loading...</div>
    </div>

    <info-modal
      v-if="$store.state.infoModal.open"
      :type="$store.state.infoModal.type"
      :title="$store.state.infoModal.title"
      :message="$store.state.infoModal.message"
      :btnLabel="$store.state.infoModal.btnLabel"
      :callback="$store.state.infoModal.callback"
    ></info-modal>

    <confirm-modal
      v-if="$store.state.confirmModal.open"
      :title="$store.state.confirmModal.title"
      :message="$store.state.confirmModal.message"
      :executeLabel="$store.state.confirmModal.executeLabel"
      :cancelLabel="$store.state.confirmModal.cancelLabel"
      :callback="$store.state.confirmModal.callback"
    ></confirm-modal>
  </div>
</template>
<script>
import InfoModal from '@/components/InfoModal.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
export default {
  components: {
    InfoModal,
    ConfirmModal
  }
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  width: 100vw;
  height: 100vh;
}
</style>
